import React, { useState } from 'react';
import './login.css';
import { userSingIn } from '../../lib/authFunction/index';
import { PopUp } from '../popup';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [showPassword, setshowPassword] = useState(false)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let res = await userSingIn({ email, password });
      setPopupMessage(res?.data?.message);
      setIsSuccess(true);
      setShowPopup(true);
        window.location.href = '/invoice';
    } catch (error) {
      console.error('Login failed:', error?.response?.data?.data?.error || error.message);
      setPopupMessage(error?.response?.data?.data?.error || 'Login failed. Please try again.');
      setIsSuccess(false);
      setShowPopup(true);
    }
  };

  return (
    <div className='login'>
      <div className="box">
        <form className='login_form' onSubmit={handleSubmit}>
          <div className="login_input">
            <h2>Login</h2>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <span>Username</span>
            <i></i>
          </div>
          <div className="login_input">
            <div className='password_login'>
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <p className='showpassword' onClick={() => setshowPassword(!showPassword)}>V</p>
              <span>Enter Password</span>
              <i></i>
            </div>

          </div>
          <input type="submit" value="Login" />
        </form>
      </div>

      {showPopup && (
        <PopUp
          message={popupMessage}
          isSuccess={isSuccess}
          onClose={() => setShowPopup(false)}
        />
      )}
    </div>
  );
};

export default Login;
